"use strict";
!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="a6f8d741-6b46-5a41-a2d5-792040a64691")}catch(e){}}();

Object.defineProperty(exports, "__esModule", { value: true });
exports.isShowInActualStatus = void 0;
const show_1 = require("../types/show");
const isShowInActualStatus = (show) => {
    if (show.status === show_1.ShowStatus.SETTLED || show.status === show_1.ShowStatus.PAID) {
        return true;
    }
    else {
        return false;
    }
};
exports.isShowInActualStatus = isShowInActualStatus;
//# sourceMappingURL=utils.js.map
//# debugId=a6f8d741-6b46-5a41-a2d5-792040a64691
